import React, { ReactElement } from 'react'
import { AdType } from 'types'
import { Breadcrumb, Breadcrumbs } from './ContentHeader'
import Sidebar from './Sidebar'

interface SidebarContainerProps {
  sidebar?: boolean
  adType?: AdType
  adPageId?: string
  children: React.ReactNode
}

const SidebarContainer: React.FC<SidebarContainerProps> = ({
  children,
  sidebar = true,
  adPageId,
  adType = 'REST'
}): ReactElement => (
  <div className={`content-sidebar ${sidebar ? '' : 'content-full'}`}>
    <div className="content">{children}</div>
    {sidebar && <Sidebar adPageId={adPageId} adType={adType} />}
  </div>
)

interface EmptySidebarProps {
  breadcrumbs?: Breadcrumb[]
  children?: React.ReactNode
}

export const EmptySidebarContainer: React.FC<EmptySidebarProps> = ({
  children,
  breadcrumbs
}): ReactElement => (
  <div className="content-sidebar">
    <div className="container-breadcrumbs max-w-container">
      {children}
      <Breadcrumbs breadcrumbs={breadcrumbs} />
    </div>
    <div className="sidebar" />
  </div>
)

export const NoSidebarContainer: React.FC<EmptySidebarProps> = ({
  children,
  breadcrumbs
}): ReactElement => (
  <div className="container-breadcrumbs max-w-container">
    {children}
    <Breadcrumbs breadcrumbs={breadcrumbs} />
  </div>
)

interface SidebarAdOnlyContainerProps {
  className?: string
  contentClassName?: string
  adType?: AdType
  adPageId?: string
  children: React.ReactNode
}

export const SidebarAdOnlyContainer: React.FC<SidebarAdOnlyContainerProps> = ({
  className,
  contentClassName,
  children,
  adPageId,
  adType = 'REST'
}): ReactElement => (
  <div className={`content-sidebar ${className ? className : ""}`}>
    <div className={`content ${contentClassName ? contentClassName : ""}`}>{children}</div>
    <Sidebar adPageId={adPageId} adType={adType} adOnly />
  </div>
)

export default SidebarContainer
